import { render, staticRenderFns } from "./ElementButton.vue?vue&type=template&id=98ce7ae4&scoped=true"
import script from "./ElementButton.vue?vue&type=script&lang=js"
export * from "./ElementButton.vue?vue&type=script&lang=js"
import style0 from "./ElementButton.vue?vue&type=style&index=0&id=98ce7ae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ce7ae4",
  null
  
)

export default component.exports